import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'

import General from '../components/SolicitudServicioOT/General'
import Aprobaciones from '../components/SolicitudServicioOT/Aprobaciones'
import Documentos from '../components/SolicitudServicioOT/Documentos'
import Cancelacion from "../components/SolicitudServicioOT/Cancelacion";

import BoxButton from '../components/Layout/BoxButton'
import ButtonStrip from '../components/Layout/ButtonStrip'

//import { showModalConfirmarAccion } from '../actions/common'
import { getSolicitud, registerCancelacion, updateSolicitud } from '../actions/solicitudservicioot'

import history from '../utils/history'

import { 
    canmbiarResponsable,
    showModalConfirmarAccion,
    getParameterByName
} from '../actions/common'

import { isAllowedToViewComponent } from '../utils/helpers'


class SolicitudServicioOT extends Component {
	constructor(props) {
		super(props)
		this.state = {
			tabs: [
				{ id: 0, caption: 'Solicitud', component: <General />, estado: 1 },
				{ id: 1, caption: 'Aprobaciones', component: <Aprobaciones />, estado: 1 },
                { id: 2, caption: 'Documentos', component: <Documentos />, estado: 4 },
                { id: 3, caption: 'Cancelación', component: <Cancelacion />, estado: 0 },
			],
			selected: 0
		}
    }
    



    componentWillMount() {
        if (this.props.match.params.id) {
            const params = new URLSearchParams(this.props.location.search);
            if (params.has("aprobacion")) {
                this.setState({selected: 1})
            }
            this.props.getSolicitud(this.props.match.params.id)
            this.props.getParameterByName('DIVISAS')
        } else {
            history.push(window.FOLDER + '/solicitudes')
        }
    }

	selectTab = (e, tab) => {
		e.preventDefault()
		this.setState({ selected: tab })
    }
    
    cancel = () => {
        this.props.showModalConfirmarAccion(true, `¿Está seguro que desea cancelar la solicitud?`, () => { this.props.showModalConfirmarAccion(false); this.props.registerCancelacion() })
    }

	render() {

		const { tabs, selected } = this.state
        const { estado, btnRComprasDisabled, solicitud, btnSaveDisabled } = this.props
        const readOnly = !isAllowedToViewComponent('responsable_compras', solicitud)
        const documentos_proceso = solicitud.get('documentos') ? solicitud.get('documentos').filter(d => d.get('estado') == 4 || d.get('estado') > 6).count() : 0
        const documentos_cancelados = solicitud.get('documentos') ? solicitud.get('documentos').filter(d => d.get('estado') == 0).count() : 0

        let boxActions;

        boxActions = [
            <BoxButton key="ba[0][1]" name="floppy-o" onClick={ () => this.props.updateSolicitud() } title="Actualizar solicitud" disabled={ btnSaveDisabled }/>,
            <BoxButton key="ba[0][2]" name="user" onClick={ () => this.props.canmbiarResponsable(solicitud, 'ACTUALIZAR_SOLICITUD_SERVICIO_OT') } title="Cambiar responsable" disabled={ btnRComprasDisabled || selected !== 0 } />,
            <BoxButton key="ba[0][3]" name="ban" onClick={() => this.cancel()} title="Aprobar cancelación solicitud" disabled={ readOnly || selected !== 3 || estado == 0} />
        ]   



		return (
        <Fragment>
            <div className="row" style={{ height: '100%', overflowX: 'hidden' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <div className="nav-container">
                        <div className="nav-tabs-section">
                            <ul className="nav-tabs-tabs">
                                {
                                    tabs.filter(x => {

                                        if (solicitud.get('documentos') && x.id === 2 && solicitud.get('documentos').count() === 0) return null;

                                        if (estado == 1) {
                                            return x.id == 0 || x.id == 1 || x.id == 3
                                        } else if ((documentos_proceso > 0) && x.id === 3) {
                                            return null;
                                        } else if (estado >= 2) {
                                            return x.estado <= estado
                                        } else if (estado == 0) {
                                            if (documentos_cancelados > 0) return (x.id < 3)
                                            else return ((x.id == 0) || (x.id == 3))
                                        }


                                    }).map(x => {
                                        return (
                                            <li key={ `li01[${x.id}]` } className={ selected === x.id ? 'active' : '' }>
                                                <a onClick={ (e) => this.selectTab(e, x.id) }>{ x.caption }</a>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                        <div className="nav-main-section">
                            <div className="">
                                <ButtonStrip actions={ boxActions } />
                            </div>
                            <div className="nav-main-section-scrollable">
                                { tabs[selected].component }
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            
        </Fragment>
		)
	}
}

function mapStateToProps(state) {
    return {
        btnSaveDisabled: state.solicitudservicioot.get('btnSaveDisabled'),
        btnRComprasDisabled: state.solicitudservicioot.get('btnRComprasDisabled'),
        estado: state.solicitudservicioot.get('estado'),
        solicitud: state.solicitudservicioot.get('solicitud')
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getSolicitud: (id) => dispatch(getSolicitud(id)),
        showModalConfirmarAccion: (show, message, action) => dispatch(showModalConfirmarAccion(show, message, action)),
        canmbiarResponsable: (solicitud, type) => dispatch(canmbiarResponsable(solicitud, type)),
        registerCancelacion: () => dispatch(registerCancelacion()),  
        updateSolicitud: () => dispatch(updateSolicitud()),  
        getParameterByName: (nombre) => dispatch(getParameterByName(nombre)),    
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SolicitudServicioOT)


// WEBPACK FOOTER //
// ./src/containers/SolicitudServicioOT.jsx